<div class="container mt-3 mx-auto">
    <div class="alert alert-info" *ngIf="!limites || !limites.length">
        Não foram encontrados limites de pagamento ECG por terceiros.
    </div>

    <div *ngIf="limites && limites.length">
        <div class="italico-e-verde">atualizado em: {{ dataHoraResultado }}</div>
        <div class="table-responsive">
            <table class="table table-hover">
                <thead>
                    <tr class="text-nowrap">
                        <th scope="col" class="text-center">Pagamento de ECG por</th>
                        <th scope="col" class="text-right">Data de referência</th>
                        <th scope="col" class="text-center">Valor limite total *</th>
                        <th scope="col" class="text-center">Valor utilizado</th>
                        <th scope="col" class="text-center">Valor disponível</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let limite of limites; let i = index">
                        <td class="text-center">{{ limite.nomeTipoPagamentoEcgTerceiro }}</td>
                        <td class="text-center">{{ limite.dataReferencia | date: 'dd/MM/yyyy' }}</td>
                        <td class="text-right">R$ {{ limite.valorLimiteTotal | bnMask: 'MOEDA' }}</td>
                        <td class="text-right">R$ {{ limite.valorUtilizado | bnMask: 'MOEDA' }}</td>
                        <td class="text-right">R$ {{ limite.valorDisponivel | bnMask: 'MOEDA' }}</td>
                    </tr> 
                </tbody>
            </table>
        </div>
    </div>
</div>